import { createAction } from '@reduxjs/toolkit';

import { IFeed } from 'homepage/types/Feed';
import { HOMEPAGE } from 'store/constants/actions';

import { IHomepageTabActionsSetCurrentFeed } from 'store/types/actions';

export const setActiveTab = createAction<string | null>(HOMEPAGE.SET_ACTIVE_TAB);
export const setCurrentFeedData = createAction<IHomepageTabActionsSetCurrentFeed>(
  HOMEPAGE.SET_CURRENT_FEED_DATA,
);
export const setDefaultFeedData = createAction<IFeed | null>(HOMEPAGE.SET_DEFAULT_FEED_DATA);
export const setHomepageBackgroundPosition = createAction<number>(
  HOMEPAGE.SET_HOMEPAGE_BACKGROUND_POSITION,
);
export const setIsLoading = createAction<boolean>(HOMEPAGE.SET_IS_LOADING);
export const setOpenTabScrollPosition = createAction<number>(HOMEPAGE.SET_OPEN_TAB_SCROLL_POSITION);
export const setVisitedByBackButton = createAction<boolean>(HOMEPAGE.SET_VISITED_BY_BACK_BUTTON);
